import React from 'react';


import component, {classnames} from './component';
import GamesItem from './GamesItem';
import LoadMoreButton from './LoadMoreButton';
import {HBox, VBox} from './Box';



export default component('Games', function({data, type, width}) {

  const GamesHorizontal = component('GamesHorizontal', function({data}) {

    const renderItem = (item, idx) => (
      <VBox key={idx} isContainer={true}>
        <GamesItem key={idx} type="Short" data={item} />
      </VBox>
    );

    return (
      <HBox width={4} isContainer={true}>
        {data.map(renderItem)}
      </HBox>
    )
  });

  const GamesVertical = component('GamesVertical', function({data, width}) {

    const renderItem = (item, idx) => <GamesItem key={idx} type="Full" data={item} />;
    return (
        <div>
          {data.map(renderItem)}
        </div>
    )
  });

  return type === 'vertical'
      ? <GamesVertical width={width} data={data}/>
      : <GamesHorizontal data={data}/>;
})



// WEBPACK FOOTER //
// ./src/components/Games.js